const toggleToggle = (toggleNode) => {
  const rootNode = toggleNode.closest('.disabled-group');
  const targetNode = document.getElementById(toggleNode.getAttribute('data-target'));
  let inputNodes;

  inputNodes = rootNode.querySelectorAll('input, textarea');
  Array.from(inputNodes).forEach(node => node.disabled = true);

  inputNodes = targetNode.querySelectorAll('input, textarea');
  Array.from(inputNodes).forEach(node => node.disabled = false);
};

const delegateClickToToggle = (event) => {
  const node = event.target.closest('.disabled-group__toggle');
  if (!node) return;
  toggleToggle(node);
};

const initNode = (rootNode) => {
  const targetNode = rootNode.querySelector('.disabled-group__target_active');
  let inputNodes;

  inputNodes = rootNode.querySelectorAll('input, textarea');
  Array.from(inputNodes).forEach(node => node.disabled = true);

  inputNodes = targetNode.querySelectorAll('input, textarea');
  Array.from(inputNodes).forEach(node => node.disabled = false);
};

const initAll = () => {
  const nodes = document.querySelectorAll('.disabled-group');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('click', delegateClickToToggle);
};

export default { toggleToggle, start };
